import React from 'react';
import { Text } from '@savvy-kit/foundations/text';
import { media, useMediaQuery } from '@savvy-kit/hooks/use-media-query';
import { cn } from '@savvy-kit/lib/utils';
import { ChartPie, CreditCard, House, Landmark, Shapes, TrendingUp } from 'lucide-react';
import IconRowButton from 'src/components/mui/icon-row-button';
import { ItemType } from 'src/constants/account-link';
import { renderItemIcon } from 'src/utils/portfolio-item-display';

import { financialAccountIconColors } from '@savvy/deprecated-shared/theme';

export default function AddItemTypeSelector({ setItemType }: { readonly setItemType: (itemType: ItemType) => void }) {
  const isSmall = useMediaQuery(media.down('sm'));

  return (
    <div>
      <div className="my-4">
        <Text variant="h4">What would you like to add?</Text>
      </div>
      <div>
        <div className={cn('flex', isSmall ? 'flex-col' : 'flex-row')}>
          <IconRowButton
            onClick={() => {
              setItemType(ItemType.BANK_ACCOUNT);
            }}
            icon={renderItemIcon(financialAccountIconColors.bankAccount, <Landmark color="#fff" size={20} />)}
            title="Bank Account"
          />
        </div>
      </div>
      <div>
        <div className={cn('flex', isSmall ? 'flex-col' : 'flex-row')}>
          <IconRowButton
            onClick={() => {
              setItemType(ItemType.INVESTMENT_ACCOUNT);
            }}
            icon={renderItemIcon(financialAccountIconColors.investmentAccount, <TrendingUp color="#fff" size={20} />)}
            title="Investment Account"
          />
        </div>
      </div>
      <div>
        <div className={cn('flex', isSmall ? 'flex-col' : 'flex-row')}>
          <IconRowButton
            onClick={() => {
              setItemType(ItemType.REAL_ESTATE);
            }}
            icon={renderItemIcon(financialAccountIconColors.realEstateAsset, <House color="#fff" size={20} />)}
            title="Real Estate"
          />
        </div>
      </div>
      <div>
        <div className={cn('flex', isSmall ? 'flex-col' : 'flex-row')}>
          <IconRowButton
            onClick={() => {
              setItemType(ItemType.COMPANY_EQUITY);
            }}
            icon={renderItemIcon(financialAccountIconColors.companyEquity, <ChartPie color="#fff" size={20} />)}
            title="Company Equity"
          />
        </div>
      </div>
      <div>
        <div className={cn('flex', isSmall ? 'flex-col' : 'flex-row')}>
          <IconRowButton
            onClick={() => {
              setItemType(ItemType.OTHER_ASSET);
            }}
            icon={renderItemIcon(financialAccountIconColors.otherAssets, <Shapes color="#fff" size={20} />)}
            title="Other Asset"
          />
        </div>
      </div>
      <div>
        <div className={cn('flex', isSmall ? 'flex-col' : 'flex-row')}>
          <IconRowButton
            onClick={() => {
              setItemType(ItemType.OTHER_LIABILITY);
            }}
            icon={renderItemIcon(financialAccountIconColors.liability, <CreditCard color="#fff" size={20} />)}
            title="Liability"
          />
        </div>
      </div>
    </div>
  );
}
